import React, {useState, useCallback} from 'react';
import {connect} from 'react-redux';
import {compose} from '../../utils'
import Dadata from "../../services/dadata";
import {bindActionCreators} from "redux";
import {
    setName,
    setSurname,
    setPhone,
    setCity,
    setStreet,
    setHouse,
    setApartment,
    setDelivery,
    setOrderId,
    setStep,
    setCouponAndDiscount
} from "../../actions";
import InputMask from "react-input-mask";
import formDataComplete from "../../utils/form-data-complete";
import checkPhoneValidation from "../../utils/check-phone-validation";
import SuggestInput from "../../components/suggest-input";
import Order from "../../services/order";

import {SlideDown} from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'
import Delivery from "../../components/delivery/delivery";
import DeliveryService from "../../services/delivery";
import CouponService from "../../services/coupon";

const dadata = new Dadata();
const orderService = new Order();
const deliveryService = new DeliveryService();
const couponService = new CouponService();

const onClickCreateOrder = (props, callback, errors, setErrors) => {
    if(formDataComplete(props, errors, setErrors)) {
        return false;
    }

    callback(true);

	let priceData = props.itemData.price.split(" ");
	
	fbq('track', 'Purchase', {currency: "RUB", value: priceData[0]});
	ym(61543024,'reachGoal','64037320');

    dataLayer.push({
        "ecommerce": {
            "purchase": {
                "actionField": {
                    "id" : props.itemData.id
                },
                "products": [
                    {
                        "id": props.itemData.id,
                        "name": props.itemData.name,
                        "price": priceData[0],
                    }
                ]
            }
        }
    })
	
	gtag("event", "purchase", {
	  "send_to": 'UA-154772717-1',
	  "transaction_id": props.itemData.id,
	  "value": priceData[0],
	  "currency": "RUB",
	  "items": [
		{
		  "id": props.itemData.id,
		  "name": props.itemData.name,
		  "quantity": 1,
		  "price": priceData[0]
		}
	  ]
	});
		
	console.log('send fbq order');
	console.log(props.itemData.id);
	console.log(priceData[0]);

    orderService.create({
        geo: props.geo,
        delivery: props.delivery,
        user: props.user,
        item: props.itemData,
        deliveryPrice: props.deliveryPrice,
        coupon: props.discount.coupon,
    }).then(res => {
        callback(false);
        props.setOrderId(res.data.orderId);
        props.setStep(2);
    });
};

const onClickCheckCoupon = (coupon, props, setShowCouponMessage) => {
    if (!coupon) {
        return  false
    }

    couponService.checkCoupon(props.itemData.id, coupon).then(res => {
        props.setCouponAndDiscount(coupon, res.PRICE, res.DISCOUNT);
        setShowCouponMessage(true);
		ym(61543024, 'reachGoal', 'promo_code');
		/* console.log('coupon is on'); */
    });
}

const Step1 = (props) => {
    const {surname, name} = props.user;
    const {city, street, house, apartment} = props.geo;

    const [phoneVal, setPhoneVal] = useState("");
    const [coupon, setCouponVal] = useState("");
    const [showCouponMessage, setShowCouponMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        surname: false,
        name: false,
    });
    const clearError = useCallback((callback, field) => {
        setErrors({
            ...errors,
            field: false
        });
        callback();

    }, [errors, setErrors]);

    let phoneClasses = ["product-request__input", "phoneMask"];
    if(errors.phone) {
        phoneClasses.push("empty");
    }

    return (
        <div className="modal-content product-request__wrapper">
            <div className="modal-col product-request__col product-request__col--left">
                <figure className="product-request__pic">
                    <div className="product-request__img active">
                        <img
                            src={props.itemData.img}
                            alt=""/>
                    </div>
                </figure>

                <h3 className="product-request__name">{props.itemData.name}</h3>
                <div className="product-request__code product__current-color modalType2--model">
                    Модель:&nbsp;
                    <span id="offer_color_name_popup_76645" className="active">{props.itemData.model}</span>
                </div>
                <div className="product__price-wrapper modalType2--price active">
                    <div className="product__price-column">
                        {props.discount.value > 0 &&
                            <>
                            <div className="product-request__cost product-request__cost_old">{props.itemData.price}</div>
                            <div className="product-request__cost product-request__cost_new">{props.discount.price} ₽</div>
                            </>
                        }
                        {props.discount.value == 0 &&
                            <div className="product-request__cost product-request__cost_new">{props.itemData.price}</div>
                        }
                    </div>
                </div>

                <div className="product__price-container_mob">
                    <div className="product__price-wrapper product__price-wrapper_mob modalType2--price active">
                        <div className="product__price-column">
                            <div className="">Цена</div>
                            <div className="product-request__cost product-request__cost_old">{props.itemData.price}</div>
                        </div>
                    </div>
                    <div className="promo__container promo__container_mob">
                        <input type="promo" name="promo" className="product-request__input fix_desctop_height promo__input" disabled={props.discount.value > 0}
                               placeholder="Промокод" onChange={e => {setCouponVal(e.target.value);setShowCouponMessage(false);}} />
                        {props.discount.value == 0 &&
                        <button type="button" className="promo_btn product-request__button" onClick={e => onClickCheckCoupon(coupon, props, setShowCouponMessage)}>Применить</button>
                        }
                        {showCouponMessage &&
                        <>
                            {props.discount.value > 0 &&
                            <div className="promo__message active">
                                Промокод применен
                            </div>
                            }
                            {props.discount.value == 0 &&
                            <div className="promo__message promo__message_error active">
                                Промокод не верен
                            </div>
                            }
                        </>
                        }
                    </div>
                    {props.discount.value > 0 &&                   
					<div className="promo__success active">
                        <div className="success__row">
                            <div className="success__text">
                                Вы экономите
                            </div>
                            <div className="success__val">
                                {props.discount.value}₽
                            </div>
                        </div>
                        <div className="success__row">
                            <div className="success__text">
                                Новая цена
                            </div>
                            <div className="success__val">
                                {props.discount.price}₽
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>

            <div className="modal-col product-request__col product-request__col--right">
                <form id="pp_form_oneclick" action="" className="product-request__form">
                    <SuggestInput value={surname.value} onChange={props.setSurname}
                                  field="surname"
                                  errors={errors}
                                  setErrors={setErrors}
                                  getData={dadata.getSurname} placeholder="Фамилия" />

                    <SuggestInput value={name.value} onChange={props.setName}
                                  field="name"
                                  errors={errors}
                                  setErrors={setErrors}
                                  getData={(value) => dadata.getName(value, surname.gender)}
                                  placeholder="Имя"/>

                    <InputMask mask="+7(999)999-99-99" value={phoneVal}
                               onBlur={e => checkPhoneValidation(e.target.value, props.setPhone, setPhoneVal)}
                               onChange={e => setPhoneVal(e.target.value)}>
                        <input type="tel" className={phoneClasses.join(" ")} placeholder="Телефон"/>
                    </InputMask>

                    <SuggestInput value={city.value} onChange={e => deliveryService.getDeliveryPrice(e, props.setCity)}
                                  getData={dadata.getCity}
                                  field="city"
                                  errors={errors}
                                  setErrors={setErrors}
                                  placeholder="Населёный пункт"/>

                    <Delivery />

                    <SlideDown className="block-open-speed">
                        {city.data && (props.deliveryPrice.post || props.deliveryPrice.courier) &&
                            <>
                                <SuggestInput value={street.value} onChange={props.setStreet}
                                              getData={v => dadata.getStreet(v, city.data.city_fias_id, city.data.settlement_fias_id)}
                                              field="street"
                                              errors={errors}
                                              setErrors={setErrors}
                                              placeholder="Улица"/>
                                <div
                                    className="gresso-dadata__control-wrapper modalType2__addressContainer modalType2__addressContainer2">
                                    <div className="gresso-dadata__control-wrapper">
                                        <SuggestInput value={house.value} onChange={props.setHouse}
                                                      disalbed={street.data === undefined}
                                                      field="house"
                                                      errors={errors}
                                                      setErrors={setErrors}
                                                      getData={v => dadata.getHouse(v, street.data.settlement_fias_id, street.data.street_fias_id)}
                                                      placeholder="Дом"/>

                                        <input type="text"
                                               value={apartment.value} onChange={e => props.setApartment(e.target.value)}
                                               disabled={house.data === undefined}
                                               className="product-request__input product-request__input--small"
                                               placeholder="Квартира" autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="radioBox__container radioBox__payment">
                                    <p className="radioBox__container--title">Способ оплаты:</p>
                                    <div className="radiobox">
                                        <input className="radio_input" type="radio" checked={true}/>
                                        <label>Оплата при получении</label>
                                    </div>
                                </div>
                            </>
                        }
                    </SlideDown>

                    <div className="promo__container promo__container_dt">
                        <input type="promo" name="promo" className="product-request__input promo__input fix_desctop_height" disabled={props.discount.value > 0}
                               placeholder="Промокод" onChange={e => {setCouponVal(e.target.value);setShowCouponMessage(false);}} />
                        {props.discount.value == 0 &&
                            <button type="button" className="promo_btn product-request__button" onClick={e => onClickCheckCoupon(coupon, props, setShowCouponMessage)}>Применить</button>
                        }
                        {showCouponMessage &&
                            <>
                                {props.discount.value > 0 &&
                                <div className="promo__message active">
                                    Промокод применен
                                </div>
                                }
                                {props.discount.value == 0 &&
                                <div className="promo__message promo__message_error active">
                                    Промокод не верен
                                </div>
                                }
                            </>
                        }
                    </div>

                    <button disabled={loading} onClick={e => onClickCreateOrder(props, setLoading, errors, setErrors)} type="button"
                            className="product-request__button modalType2--submitBtn">
                        {loading && <img style={{display: "inline"}} src="/local/templates/bx-gresso/img/91.svg"/>}
                        {!loading && <span className="fast_order_step1" style={{fontSize: "16px", fontWeight: "normal", textTransform: "none"}}>Оформить заказ</span>}
                    </button>

                    <p className="modal__oferta">Нажимая на кнопку "Оформить заказ", Вы принимаете условия
                        <a href="/terms/">Публичной оферты</a>.
                    </p>
					
					<p className="modal__oferta">* Внешний вид товара может незначительно отличаться от фото.</p>
                </form>
            </div>
        </div>
    );
};

const mapStateToProps = ({delivery, deliveryPrice, user, geo, itemData, discount}) => {
    return {delivery, deliveryPrice, user, geo, itemData, discount};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setSurname,
        setName,
        setPhone,
        setCity,
        setStreet,
        setHouse,
        setApartment,
        setDelivery,
        setOrderId,
        setStep,
        setCouponAndDiscount,
    }, dispatch);
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(Step1);
